import { render, staticRenderFns } from "./login.vue?vue&type=template&id=1fbc4b2a&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=1fbc4b2a&prod&scoped=true&lang=css"
import style1 from "./login.vue?vue&type=style&index=1&id=1fbc4b2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbc4b2a",
  null
  
)

export default component.exports